import React, { useState, useEffect } from "react";
import { NotificationManager } from "react-notifications";
import { components } from "react-select";
import {
  Accordion,
  AccordionItem,
  Typography,
  Dropdown,
  Button,
  CircularLoader,
  theme,
} from "@plum-xoxo/admin-dsm";

import codeCampaignService from "../../services/codeCampaignService";
import transactionService from "../../services/transactionService";
import styled from "styled-components";
import { app_path } from "config";
import { StyledIcon } from "../../modules/Accounts/PlatformPreferences/Component/styled";
import profileService from "../../services/profileService";
import BrandApprovalWarningBanner from "../BrandApprovalWarningBanner";
import AutomationCampaignDetailsModal from "../../modules/Integrations/components/automationCampaignDetailsModal";
import ExploreMarketPlaceBlock from "./ExploreMarketPlaceBlock";
const env = process.env.NODE_ENV || "production";
const config = require(`../../config/config.${env}.json`);

const { Option } = components;

const StyledDiv = styled.div`
  gap: 20px;
`;

const StyledAccordion = styled(Accordion).attrs()`
  .eui-accordion-title {
    width: 100%;
  }
  .eui-accordion-content {
    padding: 0;
  }
  .eui-accordion-icon {
    padding: 0px 12px;
  }
`;

const StyledGap8 = styled.div`
  gap: 8px;
`;

const StyledImage = styled.img`
  border: 1px solid ${(props) => props.theme.palette.light.c200};
  border-radius: 8px;
  object-fit: cover;
`;
const StyledBorderedDiv = styled.div`
  border: 1px dashed var(--Dark-c000, #bac9de);
  border: 1px dashed var(--Dark-c000, color(display-p3 0.749 0.7882 0.8549));
  height: 226px;
`;

const StyledButton = styled(Button).attrs()`
border: 1px solid ${(props) => props.theme.palette.light.c200}
background: ${(props) => props.theme.palette.background.tertiary}
`;

const StyledOption = styled(Option)`
  border-radius: 8px;
  &:hover {
    background-color: ${(props) => props.theme.palette.light.c100};
  }
`;

const AccordionTitle = ({
  selectedSite,
  rewardType,
  enabledSites,
  domain,
  firstRewardSent,
  loader,
  loading,
}) => {
  return (
    <StyledDiv className="d-flex align-items-center justify-content-between w-100">
      <StyledDiv className="d-flex justify-content-between align-items-center">
        <StyledIcon iconName="PlumInbox" color="primary" shade="c02" />
        <div className="d-flex align-items-center">
          {rewardType !== 3 ? (
            <>
              <Typography.ButtonText>
                {!domain && rewardType === 1
                  ? "Set Redemption Marketplace"
                  : rewardType === 1
                  ? "Customise Marketplace"
                  : "Select Campaign"}
              </Typography.ButtonText>{" "}
              {firstRewardSent && (
                <Typography.ButtonText
                  color="dark"
                  shade="c100"
                  className="ml-2"
                >
                  {" ("}optional{")"}
                </Typography.ButtonText>
              )}
            </>
          ) : loader || loading ? (
            <CircularLoader />
          ) : (
            <>
              {enabledSites.length > 0 ? (
                <div>
                  <Typography.ButtonText>Select Campaign</Typography.ButtonText>
                </div>
              ) : (
                <div>
                  <Typography.H3>Create Campaign</Typography.H3>
                </div>
              )}{" "}
            </>
          )}
        </div>
      </StyledDiv>
      {rewardType === 2 && (
        <div className="d-flex align-items-center">
          <Typography.HelperText className="mb-8">
            {selectedSite?.name}
          </Typography.HelperText>
        </div>
      )}
    </StyledDiv>
  );
};

const StyledButtonNoHover = styled(Button)`
  :hover {
    background-color: transparent;
  }
`;

const SelectCampaign = (props) => {
  const {
    selectedSite,
    setSelectedSite,
    templateLoading,
    setTemplateLoading,
    emailLogo,
    setEmailLogo,
    emailHeading,
    setEmailHeading,
    setEmailTitle,
    emailSubject,
    setEmailSubject,
    selectedTemplate,
    setSelectedTemplate,
    DEFAULT_TEMPLATE,
    activeSetting,
    kybStatus,
    rewardType,
    setButtonText,
    voucherDetails,
    setVoucherDetails,
    vouchersData,
    setVouchersData,
    setDisabled,
    fetchCampaignDetails,
    setHasCampaign,
    loader,
    domain = "",
    firstRewardSent = true,
    updateEmployeeDetails,
    marketplaceError,
    setMarketplaceError,
    whatsappText,
    setWhatsappText = () => {},
    whatsappAlbumImageId,
    setWhatsappAlbumImageId = () => {},
    whatsappImage,
    setWhatsappImage = () => {},
  } = props;

  const [loading, setLoading] = useState(false);
  const [siteList, setSiteList] = useState([]);
  const [enabledSites, setEnabledSites] = useState([]);
  const [showCampaignDetailsModal, setShowCampaignDetailsModal] =
    useState(false);

  const newCampaignList = (data) => {
    return (
      <StyledOption {...data} className="d-inline-block">
        <Typography component="div" className="mb-0">
          {data?.data?.label}
        </Typography>
        {rewardType === 3 && (
          <Typography.HelperText
            color="dark"
            shade="c200"
            className="d-flex align-items-center m-0"
          >
            <Typography.HelperText color="dark" shade="c200" className="mb-0">
              {data?.data?.countryName} {" | "}
            </Typography.HelperText>{" "}
            <Typography.HelperText
              color="dark"
              shade="c200"
              className="mb-0 mx-4"
            >
              {data?.data?.currencyCode} {data?.data?.denomination_value}{" "}
              {/* {" | "} */}
            </Typography.HelperText>{" "}
            {/* <Typography.HelperText color="dark" shade="c200" className="mb-0">
              {data?.data?.product_count}{" "}
              {data?.data?.product_count > 1 ? "brands" : "brand"}
            </Typography.HelperText> */}
          </Typography.HelperText>
        )}
      </StyledOption>
    );
  };

  const customiseCatalog = (row) => {
    if (row && row.id) {
      props.history.push({
        pathname: `/${app_path}/campaign/xoxo-campaign/`,
        state: JSON.stringify({
          createCampaign: 0,
          selected_site: row,
          fromPathname: `/${app_path}/xoxo-points/`,
        }),
      });
    }
  };

  const editCampaign = () => {
    props.history.push({
      pathname: `/${config.app_path}/campaign/xoxo-link-campaign/`,
      state: JSON.stringify({
        createCampaign: 0,
        campaignDetails: voucherDetails,
        amount_redeemed: selectedSite.amount_redeemed,
        fromPathname: `/${app_path}/xoxo-link`,
      }),
    });
  };

  const createNewSite = () => {
    // localStorage.setItem(
    //   "voucherCreateCampaign",
    //   btoa(JSON.stringify({ ...this.state }))
    // );
    props.history.push({
      pathname: `/${app_path}/campaign/xoxo-campaign/`,
      state: {
        fromVoucher: 1,
        createCampaign: 1,
      },
    });
  };

  const redirectToCreateCampaign = () => {
    if (rewardType === 2) fetchVoucherCampaign();
    else if (rewardType === 3) fetchCampaignList();
    props.history.push({
      pathname: `/${app_path}/campaign/xoxo-${
        rewardType === 2 ? "code" : "link"
      }-campaign/`,
      state: JSON.stringify({
        createCampaign: 1,
        fromXoxoLinkSendRewards: true,
        fromPathname: `/${app_path}/xoxo-${rewardType === 2 ? "code" : "link"}`,
      }),
    });
    // this.props.history.push('/admin/campaign/xoxo-link-campaign')
  };

  const getTemplateDetails = (selected_id) => {
    let { buttonText = "Redeem now" } = props;
    let email_heading = "",
      email_subject = "",
      email_logo = "",
      email_title = "";
    setTemplateLoading(false);
    if (selected_id > 0) {
      setLoading(true);
      setTemplateLoading(true);
      transactionService
        .getTemplateDetails({ template_id: selected_id })
        .then((resp) => {
          if (
            resp &&
            resp.getTemplateDetails &&
            !resp.getTemplateDetails.error &&
            resp.getTemplateDetails.data
          ) {
            email_heading = resp.getTemplateDetails.data.message;
            email_title = resp.getTemplateDetails.data.heading;
            email_subject = resp.getTemplateDetails.data.subject;
            email_logo = resp.getTemplateDetails.data.logo;
            buttonText =
              resp.getTemplateDetails.data.redeem_button_text || "Redeem now";
            selectedTemplate.image_id =
              resp.getTemplateDetails.data.album_img_id;
            selectedTemplate.image_url =
              resp.getTemplateDetails.data.img_path ||
              DEFAULT_TEMPLATE.image_url;
            selectedTemplate.img_path = resp.getTemplateDetails.data.img_path;
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
        })
        .then(() => {
          setEmailLogo(email_logo);
          setEmailHeading(email_heading);
          setEmailTitle(email_title);
          setEmailSubject(email_subject);
          setSelectedTemplate(selectedTemplate);
          setTemplateLoading(false);
          setButtonText(buttonText);
          setLoading(false);
          //   this.getInitialAlbum(selectedTemplate);
        });
    } else {
      () => {
        setSelectedTemplate(JSON.parse(JSON.stringify(DEFAULT_TEMPLATE)));
        setEmailSubject("Congratulations! You have been rewarded");
        setEmailHeading("You have received Plum E-Gift Card. Congratulations!");
        setEmailTitle("Congratulations!");
        setTemplateLoading(false);
        // setEmailLogo();
      };
    }
  };

  const getWhatsappTemplateDetail = (whatsapp_template_id) => {
    if (whatsapp_template_id > 0) {
      transactionService
        .getWhatsappTemplateDetail({
          template_id: whatsapp_template_id,
        })
        .then((resp) => {
          const data = resp?.getWhatsappTemplateDetail?.data || {};
          setWhatsappAlbumImageId(data?.album_img_id);
          setWhatsappText(data?.text);
          setWhatsappImage(data?.img_path);
        });
    } else {
      setWhatsappAlbumImageId(0);
      setWhatsappText("Congratulations! You have been rewarded");
    }
  };

  const handleSite = (event) => {
    setSelectedSite(event);
  };

  //code campign
  const fetchVoucherCampaign = () => {
    let site_list = [],
      enabled_sites = [],
      selected_site = {};
    setLoading(true);
    codeCampaignService
      .fetchVoucherSites({
        limit: rewardType === 1 ? 1 : null,
      })
      .then((response) => {
        if (response && response.fetchSite && !response.fetchSite.error) {
          site_list = response.fetchSite.data ? response.fetchSite.data : [];
          enabled_sites = [];
          site_list.map((item) => {
            item["label"] = item.name;
            item["value"] = item.id;
            item.status === 1 ? enabled_sites.push(item) : null;
          });
          const siteSessionData = JSON.parse(
            sessionStorage.getItem("xoxoCodeState")
          );
          const isSiteSessionData = siteSessionData?.selectedSite?.template_id;
          if (sessionStorage.getItem("newCampaignName")) {
            const searchName = sessionStorage.getItem("newCampaignName");
            const foundObject = enabled_sites.findIndex(
              (obj) => obj.name === searchName
            );
            selected_site = enabled_sites[foundObject];
            if (foundObject > 0) {
              sessionStorage.removeItem("newCampaignName");
              NotificationManager.error(`${searchName} campaign selected.`);
            }
          } else if (isSiteSessionData) {
            selected_site = siteSessionData.selectedSite;
          } else if (Object.values(selectedSite).length > 0) {
            selected_site = selectedSite;
          } else {
            selected_site = enabled_sites[0];
          }
          selectedSite && selectedSite.template_id > 0
            ? getTemplateDetails(selectedSite.template_id || 0)
            : null;
          selectedSite
            ? getWhatsappTemplateDetail(selectedSite.whatsapp_template_id || 0)
            : null;
        } else {
          const message =
            response.fetchSite.message && response.fetchSite.message[0]
              ? response.fetchSite.message[0]
              : "Something Went Wrong";
          NotificationManager.error(message, "Error");
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .then(() => {
        setSiteList(site_list);
        setEnabledSites(enabled_sites);
        setSelectedSite(selected_site);
        setTimeout(() => setLoading(false), 1000);
      });
  };

  const sendRewardAfterRecharge = () => {
    const total = parseFloat(
      sessionStorage.getItem("xoxoLinkGrandTotal") || 0
    ).toFixed(2);
    if (props.location?.state !== undefined) {
      let data;
      try {
        data = JSON.parse(this.props.location.state);
      } catch (e) {
        console.error("Error in parsing data", e);
      }
      if (data && data.paymentStatus) {
        if (data.paymentStatus === "success" || data.paymentStatus === "fail") {
          if (data.paymentStatus === "success") {
            this.sendCode(parseFloat(total));
            this.props.history.replace({
              pathname: this.props.location.pathname,
              state: undefined,
            });
          } else {
            NotificationManager.error("Payment Failed.", "Error");
          }
        }
      }
    }
    // });
  };

  // link campaign
  const fetchCampaignList = () => {
    let enabled_sites = [];
    let data = {
      limit: 10000,
      offset: 0,
      xoxo_link: 1,
    };
    setLoading(true);
    let selected_site = {};
    let sessionData;
    let locationData;
    try {
      sessionData = JSON.parse(sessionStorage.getItem("xoxoLinkState"));
      locationData =
        props.location?.state !== undefined &&
        JSON.parse(props.location?.state);
    } catch (e) {
      console.error("Error in parsing json", e);
    }

    if (sessionData && sessionData?.selectedSite?.campaignId)
      selected_site = sessionData.selectedSite;
    profileService
      .fetchOneClickCampaignSites(data)
      .then((response) => {
        if (response.success && response.data && response.data.length) {
          response.data.map((val) => {
            if (val?.status === 1) {
              const campaign = {
                label: val.campaignName,
                value: val?.campaignId,
                ...val,
              };
              enabled_sites.push(campaign);
              if (locationData?.campaignName === val.campaignName) {
                selected_site = campaign;
              }
            }
          });
          if (!selected_site.campaignName) {
            selected_site = enabled_sites[0];
          }
          fetchCampaignDetails(selected_site);
          getTemplateDetails(selected_site?.mail_template_id || 0);
          selected_site?.sms_template_id &&
            props.getSmsDetails &&
            props.getSmsDetails(selected_site?.sms_template_id || 0);
        }
      })
      .catch((err) => {
        setLoading(false);
        NotificationManager.error("Something Went Wrong", "Error");
      })
      .then(() => {
        if (enabled_sites.length > 0) {
          setHasCampaign(true);
        }
        setEnabledSites(enabled_sites);
        sendRewardAfterRecharge();
        setSelectedSite(selected_site);
        setTimeout(() => setLoading(false));
        // NotificationManager.success(
        //   `Campaign ${selected_site?.campaignName} selected.`
        // );
      });
  };

  useEffect(() => {
    if (rewardType === 1 || rewardType === 2) fetchVoucherCampaign();
    else if (rewardType === 3) fetchCampaignList();
  }, []);

  // useEffect(() => {
  //   if (!voucherDetails?.campaignId) fetchCampaignList();
  // }, [voucherDetails]);
  useEffect(() => {
    if (rewardType === 3 && selectedSite?.campaignId) {
      fetchCampaignDetails(selectedSite);
      getTemplateDetails(selectedSite?.mail_template_id);
    } else {
      selectedSite && getTemplateDetails(selectedSite?.template_id);
      selectedSite &&
        getWhatsappTemplateDetail(selectedSite?.whatsapp_template_id);
    }
    if (
      !(selectedSite?.name || selectedSite?.campaignName) &&
      enabledSites?.length
    ) {
      setSelectedSite(enabledSites[0]);
    }
    selectedSite?.sms_template_id &&
      props.getSmsDetails &&
      props.getSmsDetails(selectedSite?.sms_template_id || 0);
  }, [selectedSite?.name, selectedSite?.campaignId]);
  return (
    <>
      <StyledAccordion
        className="mt-16"
        activeItem={rewardType === 3 || activeSetting === 2 ? 0 : null}
      >
        <AccordionItem
          title={
            <AccordionTitle
              selectedSite={selectedSite}
              rewardType={rewardType}
              enabledSites={enabledSites}
              domain={domain}
              firstRewardSent={firstRewardSent}
              loader={loader}
              loading={loading}
            />
          }
          className="w-100"
        >
          <hr className="mb-0" />
          <>
            {(rewardType === 1 || rewardType === 2 || rewardType === 3) &&
              (!domain || !firstRewardSent) && (
                <ExploreMarketPlaceBlock
                  domain={domain}
                  rewardType={rewardType}
                  updateEmployeeDetails={updateEmployeeDetails}
                  marketplaceError={marketplaceError}
                  setMarketplaceError={setMarketplaceError}
                  {...props}
                />
              )}

            {rewardType == 1 && domain ? (
              <div className="d-flex p-24">
                <Typography.ButtonText className="d-flex align-items-center">
                  Global Redemption Marketplace
                </Typography.ButtonText>
                <StyledButtonNoHover
                  variant="plain"
                  color="primary"
                  onClick={() =>
                    customiseCatalog({
                      id: "0",
                      name: "Global Rewards Catalogue",
                      status: 1,
                      label: "Global Rewards Catalogue",
                    })
                  }
                  id="xoxo-point-customize-catalog-btn"
                >
                  Customise
                </StyledButtonNoHover>
              </div>
            ) : null}
            {(rewardType == 2 || rewardType === 3) && domain && (
              <>
                {loading ? (
                  <div className="d-flex align-items-center justify-content-center p-24">
                    <CircularLoader />
                  </div>
                ) : enabledSites.length > 0 ? (
                  <div className="col px-0 ml-4 p-24">
                    <Dropdown
                      className="w-50 px-0"
                      value={selectedSite}
                      onChange={(e) => {
                        handleSite(e);
                      }}
                      options={enabledSites}
                      customListHead={
                        <Typography component="div">
                          <a
                            className="linkColor"
                            onClick={() =>
                              rewardType === 1
                                ? createNewSite(siteList)
                                : redirectToCreateCampaign()
                            }
                          >
                            <Typography
                              color="blue"
                              shade="c200"
                              className="text-left mb-0 my-8 pl-4"
                            >
                              Create New Campaign +
                            </Typography>
                          </a>
                        </Typography>
                      }
                      name="Site List"
                      isDisabled={false}
                      components={{ Option: newCampaignList }}
                      isSearchable={true}
                      placeholder={"Select Site"}
                      isLoading={loading}
                      styles={{
                        option: (base, state) => ({
                          ...base,
                          backgroundColor: "transparent",
                          color: state.isSelected
                            ? `${theme.palette.primary.c03} !important`
                            : `${theme.palette.dark.c300} !important`,
                        }),
                      }}
                    />
                    {rewardType === 3 &&
                      (loading || loader ? (
                        <CircularLoader />
                      ) : (
                        <>
                          <Typography className="mt-24">
                            {voucherDetails?.vouchers?.length}{" "}
                            {voucherDetails?.vouchers?.length > 1
                              ? "products"
                              : "product"}{" "}
                            . {selectedSite?.countryName}.{" "}
                            {selectedSite?.currencyCode}{" "}
                            {selectedSite?.denomination_value}{" "}
                            <Button
                              variant="plain"
                              color="primary"
                              onClick={editCampaign}
                            >
                              Edit
                            </Button>
                          </Typography>
                          {loader ? (
                            <CircularLoader />
                          ) : (
                            <StyledGap8 className="d-flex flex-wrap">
                              {vouchersData?.slice(0, 6)?.map((item, index) => (
                                <>
                                  <StyledImage
                                    src={item.image}
                                    width="161px"
                                    height="106.841px"
                                  />
                                </>
                              ))}
                              <StyledButton
                                variant="plain"
                                color="primary"
                                onClick={() =>
                                  setShowCampaignDetailsModal(true)
                                }
                              >
                                View Details
                              </StyledButton>
                            </StyledGap8>
                          )}
                        </>
                      ))}
                    {firstRewardSent ? (
                      <BrandApprovalWarningBanner kybStatus={kybStatus} />
                    ) : null}
                  </div>
                ) : (
                  <div className="w-100 p-24">
                    <StyledBorderedDiv className="d-flex align-items-center justify-content-center w-100 flex-column">
                      <Typography.HelperText color="dark" shade="c200">
                        Add products to create your first link campaign
                      </Typography.HelperText>
                      <Button
                        onClick={redirectToCreateCampaign}
                        className="mt-12"
                      >
                        Create New
                      </Button>
                    </StyledBorderedDiv>
                  </div>
                )}
              </>
            )}
          </>
        </AccordionItem>
      </StyledAccordion>
      <AutomationCampaignDetailsModal
        campaignDetails={voucherDetails}
        editCampaign={editCampaign}
        showAutomationCampaignDetailsModal={showCampaignDetailsModal}
        toggleAutomationCampaignDetailsModal={() =>
          setShowCampaignDetailsModal(!showCampaignDetailsModal)
        }
      />
    </>
  );
};

export default SelectCampaign;
